/**
 * 用户管理
 */
import React from 'react';
import { Input, Button, Row, Col, Icon, Tooltip } from 'antd';
import PageLayout from '../../ui/PageLayout';
import UserEdit from './UserEdit';
import UserResetPassword from './UserResetPassword';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import { global_data } from '../../ui/auth'

class UserIndex extends React.Component {

    columns = [{
        title: '用户名',
        dataIndex: 'username',
        width: '10%',
    }, {
        title: "名称/姓名",
        dataIndex: 'name',
        width: '10%',
        // }, {
        //     title: '身份证',
        //     dataIndex: 'idNo',
        //     width: '10%',
    }, {
        title: '用户类型',
        dataIndex: 'type',
        width: '10%',
        format: { 0: '普通员工', 1: '开票人员', 2: "代办", 3: '租户', 4: "商城用户" }
        // }, {
        //     title: '邮箱',
        //     dataIndex: 'email',
        //     width: '10%',
    }, {
        title: '电话',
        dataIndex: 'tel',
        width: '10%',
        // }, {
        //     title: '备注',
        //     dataIndex: 'remark',
        //     width: '10%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '10%',
        format: { 0: '正常', 1: '删除', 2: '停用' }
    }, {
        title: '所属公司',
        dataIndex: 'memberName',
        width: '10%'
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("SYS_USER_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_USER_RESET")?
                <Tooltip title="重置密码">
                    <Icon type="lock" theme="filled" className="table-operate-icon" onClick={this.reset.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_USER_ENABLE")?
                <Tooltip title="启用">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, record.username)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_USER_DISABLE")?
                <Tooltip title="停用">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, record.username)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        resetVisible: false,
    };

    add = () => {
        this.setState({ editData: {} });
        this.showModal();
    }

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };

    update = (info, e) => {
        if (info.roleId !== undefined && info.roleId != null && !(info.roleId instanceof Array)) {
            info.roleId = info.roleId.split(",");
        }
        if (info.orgCode !== undefined && info.orgCode != null && !(info.orgCode instanceof Array)) {
            info.orgCode = info.orgCode.split(",");
        }
        this.setState({ editData: info });
        this.showModal();
    }

    //启用
    enable = (info, e) => {
        messager.confirm("是否启用该用户？", () => {
            http.post({
                url: '/user/enableUser',
                data: { username: info },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("启用成功！");
                }
            });
        });
    }

    //停用
    disable = (info, e) => {
        messager.confirm("是否停用该用户？", () => {
            http.post({
                url: '/user/disableUser',
                data: { username: info },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("停用成功！");
                }
            });
        });
    }

    //重置用户密码
    reset = (info, e) => {
        this.setState({ editData: info, resetVisible: true });
    }

    hiddenResetModal = () => {
        this.setState({ resetVisible: false });
    }

    //查询条件
    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData["username"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={8}>
                                <Input.Search
                                    placeholder="用户名/姓名"
                                    onSearch={this.inputSearch}
                                    enterButton
                                />
                            </Col>
                            {global_data.authCode.includes("SYS_USER_ADD")?
                            <Col span={16} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.add}>新增</Button>
                            </Col>
                            :""}
                        </Row>
                    )}
                    rowKey="username" url="/user/findUserPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <UserEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <UserResetPassword
                    visible={this.state.resetVisible}
                    onCancel={this.hiddenResetModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }
}

export default UserIndex;